/**
 * Goods Sales Store
 *
 * @author minkyoung.park@emcast.com
*/
// states
const state = {
    progress: 0,
}

// getters
const getters = {}


// actions
const actions = {
    SET_PROGRESS({ commit }, value) {
        commit('SET_PROGRESS_STORE', value)
    }
}


// mutations
const mutations = {
    SET_PROGRESS_STORE(state, value) {
        state.progress = value
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}